<template>
	<section v-if="false" ref="el" data-component="club-classes" data-section-intersect="light" :data-anchor="$t('classes', 'Aulas')">
		<div class="row align-center">
			<div class="xxlarge-6 small-10 xsmall-12 col">
				<p class="-subhead-2 -uppercase upper-title">{{ upperTitle }}</p>
			</div>
		</div>

		<div class="row align-center">
			<div class="xxlarge-16 col main-col">
				<RollingTitle :label="title" />
			</div>
		</div>

		<ClassesGrid ref="classesRef" :list="computedDataRef" type="slider" hydrate-on-idle />
	</section>
</template>

<script setup>
import { gsap, ScrollTrigger } from 'gsap/all'
import.meta.client && gsap.registerPlugin(ScrollTrigger)

import { RollingTitle } from '~/components/primitives'
import ClassesGrid from '~/components/fragments/ClassesGrid/ClassesGrid.vue'

import { removeSpacesAndAccents } from '~/utils/strings'

import { useStringTranslation } from '@/i18n'

const props = defineProps({
	upperTitle: { type: String, default: '' },
	title: { type: String, default: '' },
	list: { type: Array, default: () => [] },
	classes: { type: Array, default: () => [] },
	api: { type: [Boolean, String], default: false },
})
const context = inject('pageContext')
const classesRef = ref(null)
const el = ref(null)
const $t = useStringTranslation()

let observer

// const { data, pending, error } = useAsyncData(props.api, () => $fetch(props.api))

const computedDataRef = ref([])
const computedClasses = () => {
	if (!props.api) return false
	if (props.list?.length) return props.list
	else if (props.api) return props.classes.filter((item1) => data.value.some((item2) => removeSpacesAndAccents(item1.title).toLowerCase() === removeSpacesAndAccents(item2.nome_turma).toLowerCase()))
	else return false
}

const setup = () => {
	if (!props.api) return
	watch(
		data,
		(newData) => {
			if (newData) {
				computedDataRef.value = computedClasses()
			}
		},
		{ immediate: true }, // Run immediately if data is already available
	)

	nextTick(() => {
		classesRef.value?.setupEnterAnimation()
	})
}

const init = () => {
	if (!props.api) return
	observer = ScrollTrigger.create({
		trigger: el.value,
		onEnter: () => classesRef.value?.enterAnimation(),
	})
}

const kill = () => {
	observer?.kill()
}

onBeforeUnmount(() => kill())

onMounted(() => {
	if (!props.api) return
	context.$page.loader.loaded.then(() => setup())
	context.$page.loader.ready.then(() => init())
})
</script>

<style lang="scss" scoped>
[data-component='club-classes'] {
	position: relative;

	display: flex;
	flex-direction: column;
	width: 100%;
	gap: rs(48);
	padding: rs(60) 0;

	background-color: var(--color-darkBrown);
	color: var(--color-subduedYellow);

	.main-col {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: rs(48);

		.title {
			@include max-screen($xsmall) {
				@include title-2;

				:deep(.label),
				:deep(.label-spacing) {
					@include title-2;
				}
			}
		}
	}

	.upper-title {
		text-align: center;
	}
}
</style>
